export default "__VITE_ASSET__RuvBGhcU__"